<template lang="pug">
vm-row.information__wrapper(vm-w="12" vm-type="flex" vm-justify="center")
  vm-col.card__wrapper(vm-sm=12 vm-md=6 vm-lg=12)
    .card.card-flex2
      .status__absolute(:style="`background-color: ${status_color}`")
        span {{ status_display_receptions }}
      .card-body
        vm-row(vm-w="12" vm-type="flex" vm-justify="center" class="heading_title")
          h4 Recepciones A proveedor
        vm-table(max-height="350px" :data="receptions" class="table")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('supplier_shippment.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column === 'purchase_order'") {{ data[indextr][column].folio }}
                slot(v-if="column === 'supplier'") {{ data[indextr]['purchase_order']['supplier'].name }}
                slot(v-if="column == 'product'") {{data[indextr]['product']['name']}}
                slot(v-if="column == 'quantity_received'") {{data[indextr]['received_quantity']}}
                slot(v-if="column == 'created_by'") {{data[indextr]['user'].name}}
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('SendingReceptionInformation')

export default {
  name: 'ReceptionsDetailsTable',
  props: {
    sale: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    columns: [
      'purchase_order',
      'supplier',
      'product',
      'quantity_received',
      'created_by'
    ]
  }),
  computed: {
    ...mapGetters([]),
    receptions () {
      if (this.sale.receptions) {
        return this.sale.receptions
      }
    },
    status_display_receptions () {
      if (this.sale.status_display_receptions) {
        return this.sale.status_display_receptions
      }
    },
    status_color () {
      return this.sale.status_display_receptions === 'Completo' ? 'rgb(23, 201, 100)' : 'rgb(255, 130, 0)'
    }
  },
  methods: {
    ...mapActions([
      'setModalVisible'
    ])
  }
}
</script>

<style lang="scss" scoped>
.table {
  padding-left: 0 !important;
  .vm-table-text {
    padding-left: 0 !important;
  }
}

.information__wrapper {
  .card__wrapper {
    padding: 15px;
  }
  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
    height: 100% !important;
    .card-body {
      padding: 10px !important;
      width: 100%;
      height: 100%;
    }
  }
}

.card-flex2 {
  position: relative;
  display: flex;
  flex-direction: column;
}

.card {
  padding: 10px !important;
  height: 100% !important;
  .card-body {
    padding: 10px !important;
    width: 100%;
    height: 100%;
  }
}

.heading_title {
  h4 {
    span {
      color: #026481;
    }
  }
}

.input__wrapper,
.actions__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.status__absolute {
  padding: 10px;
  position: absolute;
  top: 5px;
  left: 5px;
  border-radius: 0.5em;
  span {
    color: #fff;
    font-weight: bold;
  }
}
</style>
